import React, { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import { Form } from 'react-final-form';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import validations from 'validations';
import AuthContext from 'providers/Auth/Auth.context';
import PasswordField from 'components/PasswordField';
import { useNavigate, useSearchParams } from 'react-router-dom';
import classNames from 'classnames';
import AuthPageWrapper from 'components/AuthPageWrapper';
import './ResetPassword.styles.scss';

type ResetPasswordProps = Record<string, any>;

const ResetPassword: React.FC<ResetPasswordProps> = ({ className }) => {
  const { t } = useTranslation();
  const { resetPasswordRequest } = useContext(AuthContext);
  const { popSuccess } = useContext(PopNotificationsContext);

  const [searchParams] = useSearchParams();
  const token = decodeURI(searchParams.get('token') || '');
  const navigate = useNavigate();
  const classes = classNames('reset-password-page', className);

  const handleSubmit = useCallback(
    ({ newPassword }: { newPassword: string }) => {
      resetPasswordRequest(newPassword, token, () => {
        popSuccess(t('signup-password-success'));
        navigate('/login');
      });
    },
    [resetPasswordRequest, token, popSuccess, t, navigate],
  );

  return (
    <AuthPageWrapper title={t('reset-password-title')}>
      <Form
        onSubmit={handleSubmit}
        render={({ handleSubmit, submitting, valid }) => (
          <form onSubmit={handleSubmit} className={classes}>
            <PasswordField
              placeholder={t('new-password')}
              label={t('new-password')}
              name="newPassword"
            />

            <PasswordField
              name="confirmPassword"
              placeholder={t('confirm-password')}
              label={t('confirm-password')}
              validate={validations.isFieldEqualTo(
                'newPassword',
                t('confirm-password-validation-message'),
              )}
            />
            <Button type="submit" disabled={submitting || !valid}>
              {t('change')}
            </Button>
          </form>
        )}
      />
    </AuthPageWrapper>
  );
};

export default ResetPassword;
